export class UserProfileModel {
    userId: number;
    username: string;
    firstname: string;
    surname: string;
    email: string;
    mobileNumber: string;
    password: string;
    confirmPassword: string;
    checkingUsername: boolean;
    externalId: string;
    imageUrl: string;
    isNew: boolean;

    constructor(userId: number, username: string, firstname: string,  surname: string, email: string, mobileNumber: string, imageUrl: string, externalId: string) {

    }

    static fromJson(jsonObject: any) {

        return new this(jsonObject.UserId,
            jsonObject.UserName,
            jsonObject.FirstName,
            jsonObject.Surname,
            jsonObject.Email,
            jsonObject.MobileNumber,
            jsonObject.ImageUrl,
            jsonObject.ExternalId);
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/account/profile/userprofile.model.ts